(function slectListDefinition(global) {
  "use strict";

  var ELLIPSIS = '...';
  var TEMPLATES = {
    MAIN_INPUT: '/components/selectList/mainInput.compile.html',
    LIST_RECORD: '/components/selectList/listRecord.compile.html',
    POPUP_AREA: '/components/selectList/popup.compile.html'
  };
  var LOAD_MARGIN = 50;

  /**
  * Поле с выпадающим списком.
  *
  * @class WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl;
  * @extends BaseObject
  * @mixes WebAccess.mixins.pluginMixin
  * @since 5.2.0.1300
  * @param {string} containerSelector Блок, содержащий таблицу;
  * @param {WebAccess.components.dataViews.DataProvider} dataProvider Класс, предоставляющий данные для поля с выпадающим списком;    
  * @param {Object} defaults Дополнительные параметры;
  * @property {String} className Имя класса
  * @property {String} instanceID Идентификатор поля с выпадающим списком
  * @property {String} listInstanceID Идентификатор выпадающего списка
  * @property {String} dataProvider Класс, предоставляющий данные поля с выпадающим списком  
  * @property {String} minWidth Минимальная ширина выпадающего списка  
  * @property {object} state Объект, хранящий параметры текущего поля
  */
  var SelectListControl = global.SelectListControl = BaseObject.extend([WA.mixins.pluginMixin], {
    className: "SelectListControl",
    instanceID: null,
    listInstanceID: null,
    containerSelector: null,
    dataProvider: null,
    state: {},
    minWidth: 260,

    _jContainer: null,
    _jDropDownIcon: null,
    _jWait: null,
    _jInput: null,
    _jOk: null,
    _jCancel: null,
    _jCheckBoxContaier: null,

    _spinnerTimeout: null,

    init: function (containerSelector, dataProvider, defaults) {
      var me = this;

      me._super();
      me.state = {
        selectedRecords: []
      };

      me.state = $.extend({}, me.state, defaults);

      me.dataProvider = dataProvider;
      me.instanceID = generateUniqueID();
      me.listInstanceID = generateUniqueID();
      me.containerSelector = containerSelector;
      me._jContainer = $(containerSelector);
      me._render();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отрисовка контрола и вставка его в контейнер
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_render    
    * @private 
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _render: function () {
      var me = this;
      var template = WA.templates.render(TEMPLATES.MAIN_INPUT, {
        ID: me.instanceID,
        initialValue: me._getInputValue()
      }).done(function (html) {
        me._jContainer.html(html);
        me._initControls();
        me._bindEvents();
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение значения основного input-а
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_getInputValue
    * @private
    * @since 5.2.0.1300
    * @return {String} значение
    */
    _getInputValue: function () {
      var me = this;
      return ((me.state.selectedRecords && me.state.selectedRecords.length) || (me.state.notSelectedRecords && me.state.notSelectedRecords.length)) ? ELLIPSIS : me.state.like;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение jquery объектов контролов
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_initControls
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _initControls: function () {
      var me = this;
      me._jDropDownIcon = $('.DropDown_Arrow', me.containerSelector);
      me._jInput = $('input.input', me.containerSelector);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Навешивание событий на существующие контролы поля ввода
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_bindEvents
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _bindEvents: function () {
      var me = this;
      me._jDropDownIcon.click($.proxy(me.openList, me));
      me._jInput.on('change', $.proxy(me._applyLike, me));
      me._jInput.on('focus', $.proxy(me._hideEllipsis, me));
      me._jInput.on('blur', $.proxy(me._showEllipsis, me));
      me._jInput.on('keyup', $.proxy(me._applyOnEnter, me));


      if (me.state.column && me.state.column.type === 'Date') {
        // По Enter дописываем все остальные части даты. Если ввесли только день, то дописываем месяц и год. Если ввели день и месяц, то дописываем год.
        me._jInput.on('keydown.dateControl', function (e) {
          var key = e.which || e.keyCode;

          if (key === 13) {
            var inp = me._jInput;
            var date = ParseDateTime(inp);
            inp.val(formatDate(date));
            inp.change();
            me.close();
          }

          if ((key === 59 || key === 186) && e.ctrlKey) {
            var inp = me._jInput;
            inp.val(formatDate(new Date()));
            inp.change();
            me.close();
          }

        });
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Применение фильтрации при нажатии на enter в поле для like-ввода
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_applyOnEnter
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _applyOnEnter: function (e, d) {
      var me = this;
      var charCode = e.which || e.keyCode;
      if (charCode === 13) {
        me._jInput.trigger('change');
      }
      return me;
    },

    /**
    * При фокусе на поле ввода скрываем многоточие
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_hideEllipsis
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _hideEllipsis: function () {
      var me = this;
      if (me._jInput.val() === ELLIPSIS) me._jInput.val('');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * При потере фокуса показываем многоточие,  если поле пустое и есть выбранные элементы
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_showEllipsis
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _showEllipsis: function () {
      var me = this;
      if (me.state.selectedRecords && me.state.selectedRecords.length) me._jInput.val(ELLIPSIS);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Означивание элементов выпадающего списка
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_initListControls
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _initListControls: function () {
      var me = this;
      me._jList = $("#" + me.listInstanceID);
      me._jWait = me._jList.find('.jsSpinner');
      me._jCheckBoxContaier = me._jList.find('ul');
      me._jOk = me._jList.find('.jsOk');
      me._jCancel = me._jList.find('.jsCancel');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Навешивание событий на элементы выпадающего списка
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_bindListEvents
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _bindListEvents: function () {
      var me = this;
      me._jList.on('_change', function (ev, isChecked, value, display, type) {
        me.fire(SelectListControl.EVENT.ITEM_SELECT, isChecked, value, display, type);
      });
      me._jOk.on('click', $.proxy(me._applyList, me));
      me._jCancel.on('click', $.proxy(me.close, me));
      me._jCheckBoxContaier.on('scroll', $.proxy(me._handleScroll, me));

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрываем открытые контекстные меню.
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_hideOpenedControls
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl}
    */
    _hideOpenedControls: function () {
      ContextMenu.hideAll();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет, открыт ли выпадающий список.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#isOpened    
    * @since 5.2.0.1300
    * @return {Boolean} 
    */
    isOpened: function () {
      var me = this;
      var jList = $("#" + me.listInstanceID);
      return !!jList.length;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Открывает выпадающий список.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#openList    
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    openList: function () {
      var me = this;
      if (me.isOpened()) {
        me.close();
        return;
      };

      me.state.page = 0;
      me.state.skip = 0;

      me._spinnerTimeout = setTimeout(function () {
        me._jDropDownIcon.addClass('circle-spinner select-list__spinner');
      }, 200);

      me.dataProvider.load(me.state).done(function (records) {
        clearTimeout(me._spinnerTimeout);
        me._jDropDownIcon.removeClass('circle-spinner select-list__spinner');

        var partials = {
          listRecord: TEMPLATES.LIST_RECORD
        };

        var leftPosition = null;
        var winWidth = $(window).width();
        var rightPosition = (winWidth - (me._jContainer.offset().left + me._jContainer.outerWidth()));

        if (winWidth - rightPosition < me.minWidth) {
          leftPosition = me._jContainer.offset().left;
        }
        if (rightPosition === 0 && leftPosition === null) {
          rightPosition = 1; //0 воспринимается шаблоном как false и от этого right не задается
        };

        me.fire(SelectListControl.EVENT.BEFORE_LIST_OPEN, me, records);
        var template = WA.templates.render(TEMPLATES.POPUP_AREA,
          {
            instanceID: me.listInstanceID,
            values: records,
            okText: L('OK'),
            cancelText: L('CANCEL'),
            waitText: L('WAIT'),
            position: {
              right: rightPosition,
              left: leftPosition,
              top: me._jContainer.offset().top + me._jContainer.outerHeight(),
              width: me._jContainer.width(),
              minWidth: me.minWidth
            }
          }, null, null, partials).done(function (html) {
            $('body').append(html);
            me._initListControls();
            me._bindListEvents();
          });
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Запуск дозагрузки списка при прокрутке
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_handleScroll    
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    _handleScroll: function (event, data) {
      var me = this;
      var area = event.target;
      var jArea = me._jCheckBoxContaier;

      if (jArea.scrollTop() + jArea.innerHeight() >= area.scrollHeight - LOAD_MARGIN) {
        me._appendRecords();
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Дозагрузки списка при прокрутке
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_appendRecords    
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    _appendRecords: function () {
      var me = this;
      if (me.state.isPending) return;

      me.state.page++;
      me.state.isPending = true;
      me.state.skip = me.state.take * me.state.page;

      var timeout = setTimeout(function () {
        me._jWait.fadeIn(200);
      }, 500);

      me.dataProvider.load(me.state).done(function (records) {
        me.fire(SelectListControl.EVENT.BEFORE_RECORDS_APPEND, records, me);
        me.state.isPending = false;
        clearTimeout(timeout);

        me._jWait.fadeOut(400);
        _(records).each(function (record) {
          //Здесь синхронно потому, что порядок важен

          WA.templates.render(TEMPLATES.LIST_RECORD, record, false, true).done(function (line) {
            me._jCheckBoxContaier.append(line);
          });
        });
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Обработка значения like-поиска
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_applyLike    
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    _applyLike: function () {
      var me = this;
      var currentLike = (me._jInput.val() !== ELLIPSIS) ? me._jInput.val() : '';
      var recordsCount = me.state.selectedRecords.length + me.state.notSelectedRecords.length; //чтобы работал сброс по enter-у
      me.state.selectedRecords = [];
      me.state.notSelectedRecords = [];
      me.state.invertedMode = false;

      if (!me._validateLike(currentLike)) {
        me._jInput.val('');
        return me;
      }

      if (me.state.like !== currentLike || recordsCount > 0) {
        me.state.like = currentLike;
        me.fire(SelectListControl.EVENT.VALUE_CHANGED, me.getValue());
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Валидация значения like фильтра.
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_validateLike    
    * @private
    * @since 5.4.0.1035
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    _validateLike: function (value) {
      var me = this;
      switch (me.state.column.type) {
        case "Integer":
          return !isNaN(+value);
        case "Float":
          return !isNaN(+value.replaceAll(',', '.'));
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработка выбранных записей
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#_applyList    
    * @private
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    _applyList: function () {
      var me = this;
      me.state.selectedRecords = me.state.selectedRecords || [];
      me.state.notSelectedRecords = me.state.notSelectedRecords || [];

      function getElementIdFromValue(value) {
        let id = ("" + value).makeSafeString();
        if (id === '_') {
          switch (value) {
            case '+': id = 'APPROVED'; break;
            case '?': id = 'DISAPPROVED'; break;
            default: id = 'UNSPECIFIED'; break;
          }
        }
        return id;
      }

      //Убираем из списка выбранных снятые галочки
      me.state.selectedRecords = _(_(me.state.selectedRecords).map(function (record, index) {
        let id = getElementIdFromValue(record.Value);
        let jOption = me._jList.find('#' + id + '-list-option');
        if (jOption.length && !jOption.is(':checked')) {
          return
        } else {
          return me.state.selectedRecords[index]
        }
      })).compact();


      //Убираем из списка невыбранных отмеченные галочки
      me.state.notSelectedRecords = _(_(me.state.notSelectedRecords).map(function (record, index) {
        let id = getElementIdFromValue(record.Value);
        let jOption = me._jList.find('#' + id + '-list-option');
        if (jOption.length && jOption.is(':checked')) {
          return
        } else {
          return me.state.notSelectedRecords[index]
        }
      })).compact();

      /**
      * Запись входит в список обектов
      */
      var isExist = function (value, isInverted) {
        if (isInverted) {
          return !!_(me.state.notSelectedRecords).find(function (r) { return r.Value === value });
        } else {
          return !!_(me.state.selectedRecords).find(function (r) { return r.Value === value });
        }
      };


      //Добавляем в список новые отмеченные галочки 
      me._jList.find('input[type=checkbox]:checked').each(function () {
        var value = $(this).val();
        if (!isExist(value, false)) {
          me.state.selectedRecords.push({
            Type: $(this).data('type'),
            Value: value,
            DisplayValue: $(this).attr('title')
          });
        };
      });

      //Добавляем в список новые неотмеченные галочки 
      me._jList.find('input[type=checkbox]:not(:checked)').each(function () {
        var value = $(this).val();
        if (!isExist(value, true)) {
          me.state.notSelectedRecords.push({
            Type: $(this).data('type'),
            Value: value,
            DisplayValue: $(this).attr('title')
          });
        };
      });

      if (me.state.selectedRecords && me.state.selectedRecords.length) {
        me._jInput.val(ELLIPSIS);
      } else {
        me._jInput.val('');
      }

      me.state.like = '';
      me.close();
      me.fire(SelectListControl.EVENT.VALUE_CHANGED, me.getValue());
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обновляет состояние поля.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#updateState    
    * @param {Object} newState Новое состояние
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    updateState: function (newState) {
      var me = this;
      $.extend(me.state, newState);
      me._jInput.val(me._getInputValue());
      me.close();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Закрывает выпадающий список.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#close    
    * @since 5.2.0.1300
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl} 
    */
    close: function () {
      var me = this;
      if (!me._jOk) return;
      me._jOk.off('click');
      me._jCancel.off('click');
      me._jList.remove();
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значение поля.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl#getValue    
    * @since 5.2.0.1300
    * @return {Object} Значение поля.
    */
    getValue: function () {
      var me = this;
      var filterType = (me.state.selectedRecords && me.state.selectedRecords.length) ? 'In' : 'Like';
      var equalRes = null;

      var columnType = me.state.column.type;
      //Сравнение для числовых типов по лайк вводу на равно
      if (((columnType === 'Float') || (columnType === 'Integer')) && (filterType === 'Like')) {
        if (me.state.like) {
          me.state.like = me.state.like.replaceAll(',', '.');
        }
        filterType = 'Equal';
        equalRes = $.trim(me.state.like);
      }

      var value = {
        'Like': $.trim(me.state.like),
        'In': me.state.selectedRecords,
        'Equal': equalRes,
        'Type': filterType
      }

      me.fire(SelectListControl.EVENT.ON_GET_VALUE, me, value);

      if (me.state.invertedMode) {
        value.In = me.state.notSelectedRecords;
        value.Type = 'Exclude'
      };

      return value;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
    EVENT: {
      /**
      * Срабатывает перед получением значения из поля.
      *
      * @event WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl.EVENT.ON_GET_VALUE
      * @param {Object} selectList ссылка на экземпляр класса контрола
      * @param {Object} byref_value Значение      
      */
      ON_GET_VALUE: 'getValue',

      /**
      * Срабатывает при смене значения в поле.
      *
      * @event WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl.EVENT.VALUE_CHANGED
      * @param {Object} byref_value Значение      
      */
      VALUE_CHANGED: 'change',

      /**
      * Срабатывает при выборе одного из значений выпадающего списка.
      *
      * @event WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl.EVENT.ITEM_SELECT
      * @param {Object} isChecked Выбранный элемент списка.      
      * @param {Object} value Значение выбранного элемента.     
      * @param {Object} displayValue Значение поля.
      */
      ITEM_SELECT: 'select',

      /**
      * Срабатывает перед открытием выпадающего списка.
      *
      * @event WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl.EVENT.BEFORE_LIST_OPEN
      * @param {Object} selectList Ссылка на экземпляр класса поля
      * @param {Object} items Список начальных элементов выпадающего списка      
      */
      BEFORE_LIST_OPEN: 'beforeListOpen',

      /**
      * Срабатывает при добавлении новых записей в выпадающий список.
      *
      * @event WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectListControl.EVENT.BEFORE_RECORDS_APPEND
      * @param {Object} isChecked Значение      
      * @param {Object} items Новые элементы списка      
      */
      BEFORE_RECORDS_APPEND: 'beforeRecordsAppend'
    }
  });

})(window.WA.components.dataViews.gridPlugins._controls.selectList);